import { BaseService } from '@/shared/services/BaseService';
import { API_CONFIG } from '@/shared/config/api.config';
import type {
  GeneralChatSettings,
  UpdateGeneralChatSettingsRequest,
} from '../types';

class GeneralChatSettingsService extends BaseService {
  private readonly baseUrl = API_CONFIG.BACKEND_API_URL;

  async getSettings(): Promise<GeneralChatSettings> {
    const userProfile = await this.get<{
      creativity_level?: string;
      custom_instructions?: string;
    }>(`${this.baseUrl}/auth/profile/`);
    return {
      temperature: userProfile.creativity_level
        ? parseFloat(userProfile.creativity_level) / 100
        : 0.7,
      systemInstructions: userProfile.custom_instructions || '',
      kValue: 5, // This field is not stored in Django backend
    };
  }

  async updateSettings(settings: GeneralChatSettings): Promise<void> {
    const updateData: UpdateGeneralChatSettingsRequest = {
      custom_instructions: settings.systemInstructions,
      creativity_level: Math.round(settings.temperature * 100).toString(),
    };

    // PATCH the profile endpoint with the updated settings
    await this.patch<void>(`${this.baseUrl}/auth/profile/`, updateData);
  }
}

export const generalChatSettingsService = new GeneralChatSettingsService();
